import {LOCAL_STORAGE_KEYS} from "../utils/constants";
import {invokeApi} from "../utils/invokeApi";

export const fetchLearningProgramOutline = (module_code, profile_id) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN));
    let requestObj = {
        path   : `/my_dq/learning_program/fetch_outline`,
        method : 'POST',
        headers : {
            Authorization : `Bearer ${token}`
        }
    };
    requestObj['postData'] = {
        module_code,
        profile_id
    };

    return invokeApi(requestObj);
}

export const fetchLearningProgramContent = (course_code, session_code) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN));
    let requestObj = {
        path   : `/my_dq/learning_program/fetch_content`,
        method : 'POST',
        headers : {
            Authorization : `Bearer ${token}`
        }
    };
    requestObj['postData'] = {
        course_code,
        session_code
    };

    return invokeApi(requestObj);
}

export const updateContentHistory = (module_code, profile_id, history_data) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN));
    let requestObj = {
        path   : `/my_dq/learning_program/update/content_history`,
        method : 'POST',
        headers : {
            Authorization : `Bearer ${token}`
        }
    };
    requestObj['postData'] = {
        module_code,
        profile_id,
        history_data
    };

    return invokeApi(requestObj);
}

export const recordInteraction = (module_code, profile_id, session, segment, slide, slide_layout_type, interaction_input, interaction_type) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN));
    let requestObj = {
        path   : `/my_dq/learning_program/record_interaction`,
        method : 'POST',
        headers : {
            Authorization : `Bearer ${token}`
        }
    };
    requestObj['postData'] = {
        module_code,
        profile_id,
        session,
        segment,
        slide,
        slide_layout_type,
        interaction_input,
        interaction_type
    };

    return invokeApi(requestObj);
}

export const getInteraction = (module_code, profile_id, session, segment, slide, assess10) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN));
    let requestObj = {
        path   : `/my_dq/learning_program/get_interaction`,
        method : 'POST',
        headers : {
            Authorization : `Bearer ${token}`
        }
    };
    requestObj['postData'] = {
        module_code,
        profile_id,
        session,
        segment,
        slide,
        // Assessment slides are looked up by question code, not slide position —
        // question order is shuffled per learner, so position isn't stable.
        ...(assess10 ? { assess10 } : {})
    };

    return invokeApi(requestObj);
}


export const fetchPollResults = (module_code, session, segment, slide) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN));
    let requestObj = {
        path   : `/my_dq/learning_program/fetch_poll_results`,
        method : 'POST',
        headers : {
            Authorization : `Bearer ${token}`
        }
    };
    requestObj['postData'] = {
        module_code,
        session,
        segment,
        slide
    };

    return invokeApi(requestObj);
}

export const fetchDiscussionMessages = (module_code) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN));
    let requestObj = {
        path   : `/my_dq/api/discussion/messages?module_code=${module_code}`,
        method : 'GET',
        headers : {
            Authorization : `Bearer ${token}`
        }
    };

    return invokeApi(requestObj);
}

export const postDiscussionMessage = (module_code, message, slide_id) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN));
    let requestObj = {
        path   : `/my_dq/api/discussion/messages`,
        method : 'POST',
        headers : {
            Authorization : `Bearer ${token}`
        }
    };
    requestObj['postData'] = {
        module_code,
        message,
        slide_id
    };

    return invokeApi(requestObj);
}

export const updateDiscussionMessage = (id, message) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN));
    let requestObj = {
        path   : `/my_dq/api/discussion/messages/update`,
        method : 'POST',
        headers : {
            Authorization : `Bearer ${token}`
        }
    };
    requestObj['postData'] = {
        id,
        message
    };

    return invokeApi(requestObj);
}

export const deleteDiscussionMessage = (id) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN));
    let requestObj = {
        path   : `/my_dq/api/discussion/messages/delete`,
        method : 'POST',
        headers : {
            Authorization : `Bearer ${token}`
        }
    };
    requestObj['postData'] = {
        id
    };

    return invokeApi(requestObj);
}

export const finishCourseAssessmentsService = (course_code, profile_id, program_module_code) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN));
    let requestObj = {
        path   : `/my_dq/learning_program/finish_course/assessments`,
        method : 'POST',
        headers : {
            Authorization : `Bearer ${token}`
        }
    };
    requestObj['postData'] = {
        course_code,
        profile_id,
        program_module_code
    };

    return invokeApi(requestObj);
}

// Score a single session's pre/post assessment. Called in the background when a
// session is completed so the module-level finish can average across sessions.
export const finishSessionAssessmentsService = (course_code, profile_id, program_module_code, session_code) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN));
    let requestObj = {
        path   : `/my_dq/learning_program/finish_session/assessments`,
        method : 'POST',
        headers : {
            Authorization : `Bearer ${token}`
        }
    };
    requestObj['postData'] = {
        course_code,
        profile_id,
        program_module_code,
        session_code
    };

    return invokeApi(requestObj);
}